import React from "react";
import Image from "next/image";
import { AspectRatio, Flex } from "@chakra-ui/react";
import { Section, type SectionProps } from "components/section";
import { ChakraBox } from "ui/chakra-framer";
import { TextTitle } from "ui/text";
import Balancer from "react-wrap-balancer";
import posterImage from "../../../public/assets/demo-embed/poster.png";
import { NavatticDemoModal } from "./navattic-demo-modal";

type DemoEmbedProps = {
  demoId?: string;
  demoName?: string;
  title?: string;
  description?: string;
  hasBottomBorder?: boolean;
};
/**
 * Demo is only supported on desktop (lg) screens.
 */
export function DemoEmbedFull({
  title = "Start syncing data in minutes",
  description = "Check out this 5 minute interactive demo to learn how you can sync customer data to any business tool.",
  demoId,
  demoName,
  hasBottomBorder,
  ...props
}: DemoEmbedProps & SectionProps) {
  return (
    <Section
      center
      display={{ base: "none", lg: "flex" }}
      bg="new.green.50"
      themeBgColor="new.green.50"
      py={0}
      pt={24}
      pos="relative"
      {...props}
    >
      <TextTitle
        size="lg"
        align="center"
        title={<Balancer>{title}</Balancer>}
        description={<Balancer>{description}</Balancer>}
        actions={
          <NavatticDemoModal hasRightChevron demoId={demoId} demoName={demoName}>
            Start exploring
          </NavatticDemoModal>
        }
      />

      <ChakraBox
        w="100%"
        mt={{ base: 16, xl: 20 }}
        maxW="5xl"
        mx="auto"
        initial={{ scale: 0.92, y: 140 }}
        whileInView={{ scale: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true }}
      >
        <Flex w="100%" align="center" justify="center">
          <AspectRatio
            pos="relative"
            ratio={1000 / 456}
            w="100%"
            border="1px"
            borderBottom={hasBottomBorder ? "1px" : "none"}
            borderColor="new.gray.150"
            borderTopRadius="smallest"
            overflow="hidden"
          >
            <Image
              fill
              src={posterImage}
              alt="Hightouch Audiences user interface."
              sizes="100%"
              placeholder="blur"
              style={{ objectFit: "cover" }}
            />
          </AspectRatio>
        </Flex>
      </ChakraBox>
    </Section>
  );
}
